var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import Slides from '../slides';
import { Event, storage } from '../../../base/base';
import { handleAd, rel, randomString, wapactPageCount } from '../../../utils';
const { callApp } = require('@ifeng-fe/callapp');
const dotTmpl = (current, total) => {
    const dots = [];
    for (let i = 0; i < total; i++) {
        dots.push(React.createElement("span", { key: i, className: current === i ? styles.current : styles.dots }));
    }
    return React.createElement("div", { className: styles.dots_box }, dots);
};
const padding = 26;
class IndexSlides extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            content: this.props.content,
        };
        this.event = new Event();
        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        this.insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { content } = this.props;
                const infoData = [...content];
                const refs = [];
                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach((item) => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        const ref1 = React.createRef();
                        refs.push({ index: item, ref, ref1 });
                        infoData.splice(item, 0, { type: 'ad', ref, ref1 });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 0, { type: 'ad', ref });
                    }
                });
                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach((item) => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        const ref1 = React.createRef();
                        refs.push({ index: item, ref, ref1 });
                        infoData.splice(item, 1, { type: 'ad', ref, ref1 });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 1, { type: 'ad', ref });
                    }
                });
                // 广告数据整合处理完毕后，更新列表数据
                this.setState({
                    content: infoData,
                }, () => {
                    const dom = {};
                    for (const ref of refs) {
                        if (ref.ref && ref.ref.current && ref.ref1 && ref.ref1.current) {
                            dom[ref.index] = [ref.ref.current, ref.ref1.current];
                        }
                        else if (ref.ref && ref.ref.current) {
                            dom[ref.index] = ref.ref.current;
                        }
                    }
                    try {
                        adFn(dom);
                    }
                    catch (e) {
                        console.error(e);
                        this.setState({
                            content,
                        });
                    }
                });
            }
            return;
        };
        this.handleCallUpApp = (index) => {
            // console.log(index);
            const { content, handleCallUpApp } = this.props;
            const id = content[index].guid;
            const docType = 'phvideo';
            const userIdVal = randomString(32) || '';
            if (!this.isMove && handleCallUpApp) {
                if (handleCallUpApp.type === 'news') {
                    callApp({
                        client: 'newsApp',
                        docType,
                        pid: id,
                        userId: userIdVal,
                    });
                }
                else if (handleCallUpApp.type === 'video') {
                    callApp({
                        client: 'videoApp',
                        docType: 'video',
                        pid: id,
                        userId: userIdVal,
                    });
                }
            }
        };
        this.handleCallup = (item) => {
            const { secretCallUp, id, url, type, kind, noPrefixKind, wapactCount, isVideoShare } = item;
            const nodata = '';
            const doc_type = type;
            const aid = id;
            const to_url = url;
            const wapactCountConfig = wapactCount || '';
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            if (secretCallUp && !storage.getSession('secretCallSign')) {
                this.feedWapactCountFn(wapactCountConfig);
                callApp({
                    client,
                    docType: doc_type,
                    pid: aid,
                    hasComment: 1,
                    kind,
                    isSecretCall: secretCallUp,
                    secretGoUrl: url,
                    noKindFrom: noPrefixKind,
                });
            }
        };
        this.feedWapactCountFn = (config = {}) => {
            if (Object.keys(config).length > 0) {
                wapactPageCount(config);
            }
        };
        this.sliderTmpl = (item, isClone) => {
            const { newPage, content, handleCallUpApp, onItemClick } = this.props;
            const { secretCallUp } = item;
            const props = newPage
                ? {
                    target: '_blank',
                    rel,
                }
                : {};
            const slideInnerWidth = typeof window === 'object' ? document.querySelectorAll('#root')[0].clientWidth || window.innerWidth : 0;
            const windowWidth = typeof window === 'object' ? slideInnerWidth - padding : 0;
            const height = windowWidth / 2;
            const style = {
                height,
            };
            if (item.type === 'ad') {
                return React.createElement("div", { className: styles.swiper, ref: isClone ? item.ref1 : item.ref });
            }
            else if (secretCallUp) {
                return (React.createElement("div", { className: styles.swiper, style: style, onClick: this.handleCallup.bind(this, item) },
                    React.createElement("a", Object.assign({ href: item.url }, props, { "data-nomask": true }),
                        React.createElement("img", { src: item.src, width: windowWidth, height: height ? height : 0 })),
                    React.createElement("div", { className: styles.swiper_txt },
                        React.createElement("div", { className: styles.txt },
                            React.createElement("a", Object.assign({ className: styles.txt_content, href: item.url }, props, { "data-innermask": true }), item.title))),
                    React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" })));
            }
            else {
                return handleCallUpApp &&
                    Object.keys(handleCallUpApp).length > 0 &&
                    item === content[handleCallUpApp.index] ? (React.createElement("div", { className: styles.swiper, style: style, onClick: this.handleCallUpApp.bind(this, handleCallUpApp.index) },
                    React.createElement("img", { src: item.src, height: height ? height : 0 }),
                    React.createElement("div", { className: styles.swiper_txt },
                        React.createElement("div", { className: `${styles.txt} ${styles.recommendTxt}` },
                            React.createElement("span", { className: styles.recommendLogo }),
                            React.createElement("span", { className: styles.txt_content }, item.title))),
                    React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" }))) : (React.createElement("div", { className: styles.swiper, style: style, onClick: (e) => {
                        if (onItemClick) {
                            e.preventDefault();
                            onItemClick(item);
                        }
                    } },
                    React.createElement("a", Object.assign({ href: item.url }, props, { "data-nomask": true }),
                        React.createElement("img", { src: item.src, width: windowWidth, height: height ? height : 0 })),
                    React.createElement("div", { className: styles.swiper_txt },
                        React.createElement("div", { className: styles.txt },
                            React.createElement("a", Object.assign({ className: styles.txt_content, href: item.url }, props, { "data-innermask": true }), item.title))),
                    (item === null || item === void 0 ? void 0 : item.hasAdIcon) && (React.createElement("img", { className: styles.picMark, src: "https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" }))));
            }
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { ad } = this.props;
            if (ad) {
                try {
                    const callback = yield handleAd(ad);
                    callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
                }
                catch (e) {
                    console.error(e);
                }
                try {
                    this.event.trigger('init'); // 触发广告位插入方法
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    render() {
        const { content } = this.state;
        const config = {
            autoplayInterval: 3000,
            sliderTmpl: this.sliderTmpl,
            reboundWidth: 100,
            padding,
        };
        return (React.createElement("div", { className: styles.box },
            React.createElement(Slides, { content: content, config: config })));
    }
}
export default IndexSlides;
